import { Directive, Input, ViewContainerRef, TemplateRef } from '@angular/core';

@Directive({
  selector: '[uex-portal]',
})
export class PortalDirective {
  @Input('uex-portal')
  set portal(template: TemplateRef<any>) {
    if (template) { this.viewContainerRef.createEmbeddedView(template); }
  }

  constructor(
    private viewContainerRef: ViewContainerRef
  ) { }
}
